
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hospitals",
      function () {
        return require("private-next-pages/hospitals/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hospitals"])
      });
    }
  